import { CodeBehaviorsObservedCompactUpdateRecords } from "../lib/Analysis/CodeBehaviorsRecorder";
import { RecordingStatisticsForCookie } from "../lib/Analysis/Cookie";
import { SourcePageAndDestinationPageUrlRequestStatistics } from "../lib/Analysis/NetworkEventUrl";
import { IndexedCausationNode } from "../lib/Causation/CausationNode";
import { EventSearchResultsOrEventIndexOnly, SearchOptions } from "../lib/searchNetworkEvent";
import { TabEvent } from "../lib/Events";
import { InstrumentationEventDomEventFired } from "../lib/Events/InstrumentationEvent";
import { EventSearchResults } from "../lib/searchNetworkEvent";
import { UUID, DbRecordedEvent } from "../State/EvidenceDB/DatabaseTypes";
import { CanonicalSearchTermsString } from "./PoolWorkerTypes";


export const isDbNetworkEventWithSearchResults = (c: ChronologicalReportingEvent): c is EventSearchResults & {chronologicalEventIndex: number} => "searchResults" in c;

export interface EventProcessingWorkerOptions {
	recordingUuid: UUID;
	holdSearchResultsUntilFinished?: boolean;
	canonicalSearchTermsString: CanonicalSearchTermsString;
	poolWorkerUrl: string;
	includeUserEvents?: boolean;
	searchOptions?: SearchOptions;
}

export interface ToSearchWorkerStartSearchingTermsMessage extends EventProcessingWorkerOptions {
	type: 'start-searching-terms';

}
export interface ToSearchWorkerProcessNewEventsMessage {
	type: 'process-new-events';
	poolWorkerUrl: string;
	recordingUuid: UUID;
}

export type ToSearchWorkerMessage = ToSearchWorkerStartSearchingTermsMessage | ToSearchWorkerProcessNewEventsMessage;

export interface FromSearchWorkerNewResultsMessage {
	type: 'search-results';
	chronologicalEventsUpdate: NonSearchChronologicalEvent[];
	searchResultsUpdates: EventSearchResultsOrEventIndexOnly[];
	sourceDestUrlsUpdates: SourcePageAndDestinationPageUrlRequestStatistics[];
	cookieUpdates: RecordingStatisticsForCookie[];
	causationNodeUpdates: IndexedCausationNode[];
	codeBehaviorUpdates: CodeBehaviorsObservedCompactUpdateRecords;
	connectionsProcessed: number;
	eventsProcessed: number;
	ofTotalEvents: number;
	charactersProcessed: number;
	allEventsProcessedAndSearched: boolean;
}

export type NonSearchChronologicalEvent = DbRecordedEvent<InstrumentationEventDomEventFired | TabEvent>;
export type ChronologicalReportingEvent = (NonSearchChronologicalEvent | EventSearchResults) & {chronologicalEventIndex: number};
